import { IconBase, IconComponent } from './BaseIcon';

export const Error: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M19.08 26.96c0 1.69-1.39 3.08-3.08 3.08-1.69 0-3.08-1.39-3.08-3.08A3.014 3.014 0 0 1 16 23.8l.084-.001a3.014 3.014 0 0 1 2.996 3.161zm-.08-25v7.12l-1.08 11.28H14.2L13.13 9.08V2L19 1.96z" />
  </IconBase>
);
